import type { z } from "zod";

import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import {
  type CulturalObjectsPageType,
  mapDtoToCulturalObjectsPage,
  mapDtoToCulturalObjectsPoints,
  mapDtoToCulturalObjectsTypes,
} from "../model";
import type {
  CulturalObjectsDtoSchema,
  CulturalObjectsTypesDtoSchema,
} from "../model/schemas";
import type {
  CulturalObjectsPoints,
  CulturalObjectsType,
} from "../model/types";
import { searchParams } from "./params";

type DataType = {
  hero: CulturalObjectsPageType;
  list: CulturalObjectsPoints;
  filters: CulturalObjectsType[];
};

export const getCulturalObjectsPage = async () => {
  const culturalObjectsPage = strapiClient.single("cultural-objects-page");
  const culturalObjectsPoints = strapiClient.collection("cultural-objects");
  const culturalObjectsTypes = strapiClient.collection("cultural-object-types");

  const page = await culturalObjectsPage.find({
    ...searchParams.page,
  });

  const points = await culturalObjectsPoints.find({
    ...searchParams.points,
  });

  const types = await culturalObjectsTypes.find();

  return rebuild({
    hero: mapDtoToCulturalObjectsPage(page as unknown),
    list: mapDtoToCulturalObjectsPoints(
      points as z.infer<typeof CulturalObjectsDtoSchema>,
    ),
    filters: mapDtoToCulturalObjectsTypes(
      types as z.infer<typeof CulturalObjectsTypesDtoSchema>,
    ),
    seo:
      (page as { data?: { seo?: Record<string, unknown> } })?.data?.seo || {},
  }) as DataType;
};
